<template>
  <div class="article_list" v-loading="loading">
    <meta name="referrer" content="never" />
    <el-form ref="form" :model="form" class="form_box" label-width="100px" :inline="true">
      <el-row type="flex">
        <el-form-item label="发布过的公众号:" class="account_select">
          <el-select
            v-model="form.app_id"
            :clearable="true"
            placeholder="请选择/或输入关键词"
            ref="accountSelect"
          >
            <el-option
              v-for="(item, index) in publishedAppList"
              :key="index"
              :label="item.app_name"
              :value="item.app_id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发布状态:">
          <el-select v-model="form.publish_stat" placeholder="请选择" :clearable="true">
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="发布策略:">
          <el-select
            v-model="form.publish_strategy_id"
            filterable
            remote
            :clearable="true"
            placeholder="请选择/或输入关键词"
            :remote-method="remoteSearchStrategy"
            ref="strategySelect"
            @focus="selectFocus('strategySelect', 'strategyList')"
          >
            <el-option
              v-for="(item, index) in strategyList"
              :key="index"
              :label="item.strategy_name"
              :value="String(item.id)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品:">
          <el-select v-model="form.tag_product_id" :clearable="true" placeholder="请选择">
            <el-option
              v-for="item in productList"
              :key="item.id"
              :label="item.product_name"
              :value="String(item.id)"
            />
          </el-select>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="操作时间:">
          <el-date-picker
            v-model="searchTime"
            :unlink-panels="true"
            type="daterange"
            :clearable="true"
            :editable="false"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </el-form-item>
        <!-- <el-form-item label="标签:">
          <el-select v-model="form.tag_product_id" :clearable="true" placeholder="请选择">
            <el-option
              v-for="item in articleTabOptions"
              :key="item.value"
              :label="item.label"
              :value="String(item.value)"
            />
          </el-select>
        </el-form-item> -->
        <el-form-item label="标签:" class="account_select">
          <el-cascader
            v-model="tagList"
            :options="options"
            :props="tagProps"
            collapse-tags
            :show-all-levels="false"
          >
            <!-- <div slot-scope="{ node }">
              {{ node.label }}
            </div> -->
          </el-cascader>
        </el-form-item>
        <el-form-item label="关键词:">
          <el-input v-model="form.keyword" placeholder="请输入关键词" clearable />
        </el-form-item>
        <el-button type="primary" @click="searchList" class="filter_btn">筛选</el-button>
      </el-row>
    </el-form>
    <el-row class="btn_row" type="flex" justify="space-between">
      <el-col :span="12">
        <el-button type="primary" :disabled="!Boolean(sortList.length)" @click="verifyArticleList">
          发布到公众号
        </el-button>
        <el-button type="primary" :disabled="!Boolean(sortList.length)" @click="sendMiniProgram">
          发布到小程序
        </el-button>
        <!-- <el-button type="primary" :disabled="true" @click="sendMiniProgram">发布到小程序</el-button> -->
      </el-col>
      <el-col :span="5" style="text-align: right">
        <el-button type="primary" @click="createMessage">新建内容</el-button>
        <el-button @click="exportArticle" v-loading="exportLoading">导出发布记录</el-button>
      </el-col>
    </el-row>
    <el-table
      :data="tableData"
      style="width: 100%"
      class="table_row"
      :row-class-name="tableRowDisabled"
      @select="hanldeSelect"
      @select-all="hanldeSelectAll"
      ref="table"
    >
      <el-table-column type="selection" width="55" :selectable="selectable"></el-table-column>
      <el-table-column label="内容" width="430">
        <template slot-scope="scope">
          <div class="article_content">
            <el-image
              class="cover_pic"
              :class="{ unpublished: scope.row.status == 1 }"
              :src="scope.row.cover_url"
            ></el-image>
            <div class="article_info">
              <div class="article_title">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="scope.row.title"
                  popper-class="user_select_text"
                  placement="top"
                >
                  <span>{{ scope.row.title }}</span>
                </el-tooltip>
              </div>
              <div class="label_list">
                <span
                  class="product"
                  v-for="(product, index) in scope.row.tag_product_ids"
                  :key="index"
                >
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="product"
                    popper-class="user_select_text"
                    placement="top"
                  >
                    <div class="hidden_text">
                      {{ product || '-' }}
                    </div>
                  </el-tooltip>
                </span>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="scope.row.art_id"
                  popper-class="user_select_text"
                  placement="top"
                >
                  <span class="article_id hidden_text">ID：{{ scope.row.art_id }}</span>
                </el-tooltip>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="适用公众号" width="150">
        <template slot-scope="scope">
          <div class="app_roll">
            <div v-if="isAllApp(scope.row.app_infos)">全部公众号</div>
            <div v-else>
              <div v-for="(item, index) in scope.row.app_infos" :key="index">
                {{ item.app_name }}
              </div>
              <div v-if="scope.row.app_infos.length == 0">暂无适用公众号</div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="create_time" label="操作时间">
        <template slot-scope="scope">
          {{ scope.row.update_time | parseTime }}
        </template>
      </el-table-column>
      <el-table-column label="操作者">
        <template slot-scope="scope">
          {{ scope.row.last_operator_name || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="status" label="发布状态">
        <template slot-scope="scope">
          {{ statusData[scope.row.status] || scope.row.status }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="220px">
        <template slot-scope="scope">
          <div v-if="scope.row.status == 6">
            <el-button type="text" @click="changColStatus(scope.row, 1)">上架</el-button>
          </div>
          <div v-else>
            <el-button type="text" @click="editCol(scope.row)">编辑</el-button>
            <el-button type="text" @click="viewRecord(scope.row)">记录</el-button>
            <el-popover placement="bottom" width="200" trigger="click">
              <div @mouseleave="closeCopyLink">
                <div>
                  <div style="display: inline-block; width: 87px; text-align: center">
                    <Clipboard :copytext="scope.row.art_id">
                      <el-button type="text">内部链接</el-button>
                    </Clipboard>
                  </div>
                  <div style="display: inline-block; width: 87px; text-align: center">
                    <el-button @mousemove.native="openCopyLink" type="text">外部链接</el-button>
                  </div>
                </div>
                <div v-show="showCopyLink && !linkLoading">
                  <div v-if="linkUrls.length === 0" style="display: flex; justify-content: center">
                    暂无适用公众号
                  </div>
                  <div v-for="url in linkUrls" :key="url.app_id">
                    <div
                      v-if="getPublicName(url.app_id)"
                      style="display: flex; justify-content: space-between; align-items: center"
                    >
                      <div>{{ getPublicName(url.app_id) }}</div>
                      <Clipboard :copytext="url.url">
                        <el-button type="text">复制</el-button>
                      </Clipboard>
                    </div>
                  </div>
                </div>
              </div>
              <el-button
                slot="reference"
                type="text"
                @click="getLinkAddress(scope.row.art_id, 5)"
                style="margin-left: 10px"
              >
                链接
              </el-button>
            </el-popover>
            <el-button type="text" @click="changColStatus(scope.row, 6)" style="margin-left: 10px">
              下架
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination_col">
      <el-pagination
        style="background-color: #ffffff"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="g_pageSizesConfig"
        :total="total"
        :page-size="form.page_size"
        :current-page="form.page_index"
        @current-change="currentChange"
        @size-change="sizeChange"
      />
    </div>
    <article-sort-box
      v-if="sortBoxVisible"
      :class="{ overlay: sortBoxVisible }"
      @closeDialog="sortBoxVisible = false"
      @on-success="onPublishSuccess"
      @changeList="changeSelceltRow"
      ref="articleSortBox"
    />
    <recordPop
      v-if="recordPopShow"
      :art-id="targetId"
      origin="公众号"
      @closeRecord="recordPopShow = false"
    />
    <el-dialog
      class="orange_dialog"
      :visible.sync="dialogVisible"
      :show-close="false"
      :center="true"
      width="376px"
    >
      <div>确定下架该内容吗</div>
      <div class="disable">（可从"发布状态-已下架"找到已下架内容）</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="setArticleStatus(6)">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="showNoPublish"
      :modal-append-to-body="true"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="600px"
    >
      <div class="hint_title">
        您所选的文章可以用来发布的公众号，没有包含您负责的，请编辑或重新选择。
      </div>
      <div style="margin: 10px 0">以下为可发布的公众号：</div>
      <div class="no_pass_list">
        <p v-for="(item, index) in passAppArr" :key="index">&#171; {{ item.app_name }} &#187;</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showNoPublish = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="hintVoteForbidShow"
      :modal-append-to-body="true"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="600px"
    >
      <div class="hint_title">以下文章包含投票，在公众号内无法正常显示，请编辑或重新选择。</div>
      <div class="no_pass_list">
        <p v-for="(item, index) in noPassList" :key="index">&#171; {{ item.title }} &#187;</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="hintVoteForbidShow = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogHasMedia"
      :modal-append-to-body="true"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="600px"
    >
      <div class="hint_title">
        以下文章包含视频、音频，在公众号和小程序内无法正常显示，请编辑或重新选择。
      </div>
      <div class="no_pass_list">
        <p v-for="(item, index) in hasMediaList" :key="index">&#171; {{ item.title }} &#187;</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogHasMedia = false">确 定</el-button>
      </span>
    </el-dialog>
    <show-delete-mate
      :show="isShowDlete"
      :data="showMediaList"
      @affirm="confirmPublish"
      @close="isShowDlete = false"
    />
  </div>
</template>
<script>
import articleSortBox from '../components/articleSortBox/index';
import recordPop from '../components/recordPop/index';
import showDeleteMate from '../articleEdit/components/showDeleteMate';
import Clipboard from '@/components/Clipboard';
import {
  setArticleStatusApi,
  getArticleListApi,
  publishArticleToMiniApi,
  getDeletedMediaListApi,
  GetAllLabelInfoList,
  ExportArticleRecords,
} from '@/api/releaseManagement';
import {
  getStrategyList,
  GetProductInfoList,
  GetLabelInfoList,
  getAppListApi,
  getPublishedAppListApi,
} from '@/api/setUser';
import { mapGetters, mapActions } from 'vuex';
import { GetLinkAddress } from '@/api/artilceList';
export default {
  name: 'ArticleList',
  components: { articleSortBox, recordPop, showDeleteMate, Clipboard },
  data() {
    return {
      form: {
        app_id: null, // 发布账号
        publish_stat: null, // 发布状态
        publish_strategy_id: null, // 发布策略
        tag_product_id: null, // 发布产品
        // time: null, // 查询时间
        operate_time_begin: '',
        operate_time_end: '',
        keyword: null, // 关键词
        page_size: 10,
        page_index: 1,
      },
      exportForm: {},
      exportLoading: false, // 导出载入，防止多次点击
      searchTime: null,
      total: 0,
      // pubulcList: [], // 发布账号列表
      // 1.未发布 2.发布中 3.已发布到公众号 4.已发布到小程序 5.已发布到公众号和小程序 6.已下架',
      statusList: [
        {
          label: '未发布',
          value: 1,
        },
        // {
        //   label: '发布中',
        //   value: 2,
        // },
        {
          label: '已发布到公众号',
          value: 3,
        },
        {
          label: '已发布到小程序',
          value: 4,
        },
        {
          label: '已发布到公众号和小程序',
          value: 5,
        },
        {
          label: '已下架',
          value: 6,
        },
      ], // 发布状态列表
      strategyList: [], // 发布策略列表
      tableData: [], // 表格数据
      productList: [], // 产品列表
      sortList: [], // 排序信息列表
      sortBoxVisible: false, // 排序盒子开关
      dialogVisible: false, // 弹窗
      statusData: {
        1: '未发布',
        2: '发布中',
        3: '已发布到公众号',
        4: '已发布到小程序',
        5: '已发布到公众号和小程序',
        6: '已下架',
      },
      selectLimit: 8,
      strategyForm: {
        strategy_name: '',
        page_index: 1,
        page_size: 10,
      },
      pubulcForm: {
        page_index: 1,
        page_size: 999,
        status: 1,
      },
      loading: false,
      targetId: '',
      recordPopShow: false,
      passAppArr: [], // 符合要求的公众号
      showNoPublish: false,
      articleTabOptions: [],
      noPassList: [],
      hintVoteForbidShow: false,
      tagProps: {
        multiple: true,
        value: 'Id',
        label: 'LabelName',
      },
      promoteList: [],
      diseaseList: [],
      otherTagList: [],
      tagList: [],
      tabListName: {
        promoteList: 1,
        diseaseList: 2,
        otherTagList: 4,
      },
      isShowDlete: false,
      showMediaList: [],
      allPubulcList: [],
      publishedAppList: [],
      copylink: '', // 用于复制链接
      options: [],
      hasMediaList: [],
      dialogHasMedia: false,
      showCopyLink: false,
      linkKeyword: '', // 当前查询链接的文章，用于节流
      linkUrls: [], // 复制链接-h5的数组
      linkSelfUrl: '', // 复制链接-文章本身的链接
      linkLoading: false, // loading遮罩，防止用户操作过快
    };
  },
  created() {
    this.form.page_size = this.g_pageSizeDefault;
    this.getPublishedAppList();
    this.getManagerAppList();
    this.getArticleList();
    this.getProductInfoList();
    this.getStrategyArr();
    this.getAllQueryPageTag();
    this.getAppList();
    // 设置面包屑
    const breadcrumb = [
      { menu_name: '发布管理', menu_path: '' },
      {
        menu_name: '内容管理',
        menu_path: '',
      },
      { menu_name: '公众号文章列表' },
    ];

    this.$store.commit('user/setBreadcrumb', breadcrumb);
  },
  computed: {
    ...mapGetters('user', {
      pubulcList: 'getEnableAppList',
    }),
  },
  methods: {
    downloadFile(url, fileName) {
      const x = new XMLHttpRequest();
      x.open('GET', url, true);
      x.responseType = 'blob';
      x.onload = function () {
        const url = window.URL.createObjectURL(x.response);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();
      };
      x.send();
    },
    // 导出发布记录
    exportArticle() {
      this.exportLoading = true;
      const { exportForm } = this;
      delete exportForm.page_index;
      delete exportForm.page_size;
      ExportArticleRecords(exportForm)
        .then((res) => {
          this.downloadFile(res.url, '公众号记录列表.xlsx');
          res.url ? this.$message.success('导出成功') : this.$message.error('导出失败');
        })
        .catch((err) => {
          this.$message.error(err);
        })
        .finally(() => {
          this.exportLoading = false;
        });
    },
    ...mapActions('user', ['getManagerAppList']),
    // 获取搜索发布过的公众号列表
    getPublishedAppList() {
      getPublishedAppListApi()
        .then((res) => {
          this.publishedAppList = res.list;
        })
        .catch((e) => {
          console.log(e);
          this.$message.error(e.message || e);
        });
    },
    confirmPublish() {
      this.isShowDlete = false;
      this.openSortDialog();
    },
    getDeletedMediaList() {
      return new Promise((reject) => {
        this.loading = true;
        const titleData = {};
        const artIds = [];
        this.sortList.forEach((e) => {
          titleData[e.art_id] = e.title;
          artIds.push(e.art_id);
        });
        getDeletedMediaListApi({
          art_ids: artIds,
          art_type: 1,
        })
          .then((res) => {
            const { maps } = res;
            let mediaInfoArr = [];
            const showMediaList = [];
            for (const id in maps) {
              const mediaInfo = maps[id].media_info;
              const deletedMedia = maps[id].deleted_media;
              if (JSON.stringify(mediaInfo) !== '{}' || JSON.stringify(mediaInfo) !== '[]') {
                mediaInfoArr = mediaInfoArr.concat(mediaInfo);
              }
              if (JSON.stringify(deletedMedia) !== '{}' && JSON.stringify(deletedMedia) !== '[]') {
                // [{deleted_media:[],id:'',title:''}]
                showMediaList.push({
                  deleted_media: deletedMedia,
                  id,
                  title: titleData[id],
                });
              }
            }
            this.loading = false;
            const appData = {};
            const appList = [];
            mediaInfoArr.forEach((e) => {
              if (Array.isArray(e.public_list)) {
                e.public_list.forEach((p) => {
                  if (appData[p.app_id]) {
                    appData[p.app_id].count += 1;
                  } else {
                    appData[p.app_id] = {
                      count: 1,
                      item: p,
                    };
                  }
                });
              }
            });
            for (const key in appData) {
              const item = appData[key];
              if (item.count == mediaInfoArr.length) {
                appList.push(item.item);
              }
            }
            this.passAppArr = appList;
            if (showMediaList.length) {
              this.isShowDlete = true;
              this.showMediaList = showMediaList;
              return;
            }
            reject();
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            this.$message.error(e.message || e);
          });
      });
    },
    // 获取全量标签
    getAllQueryPageTag() {
      GetAllLabelInfoList()
        .then((res) => {
          res.LabelGroupList.forEach((item) => {
            this.options.push({
              LabelName: item.GroupName,
              Id: item.GroupName,
              children: item.LabelList.filter((it) => {
                return it.Status === 1;
              }),
            });
          });
        })
        .catch((e) => {
          this.$message.error(e.message || e);
        });
    },
    // 获取标签
    getQueryPageTag(type) {
      const promise = new Promise(async (resolve, reject) => {
        const params = {
          label_type: type,
          page_index: 1,
          page_size: 9999,
        };
        const res = await GetLabelInfoList(params);
        // 标签类型，10-产品推广，20-疾病科普，30-其他分类
        // promoteList: [], //  推广列表
        // diseaseList: [], //  疾病列表
        // otherTagList: [], // 其他分类列表

        const data = [];
        res.list.map((e) => {
          data.push({
            id: e.id,
            label_name: e.label_name,
            leaf: true,
          });
        });
        if (type === 10) {
          this.promoteList = data;
        } else if (type === 20) {
          this.diseaseList = data;
        } else if (type === 30) {
          this.otherTagList = data;
        }

        if (res) {
          resolve(res);
        } else {
          reject(res);
        }
      });

      return promise;
    },
    // 判断是不是全部公众号
    isAllApp(arr) {
      if (
        arr &&
        this.allPubulcList.length &&
        arr.length &&
        this.allPubulcList.length == arr.length
      ) {
        let flag = true;
        for (let i = 0; i < this.allPubulcList.length; i++) {
          const item = this.allPubulcList[i];
          flag = arr.find((e) => {
            return e.app_id == item.app_id;
          });
          if (!flag) {
            break;
          }
        }
        return flag;
      }
      return false;
    },
    // 查看数据
    viewData() {},
    getLinkAddress(id, type) {
      // 获取外部链接
      if (this.linkKeyword !== id) {
        this.linkKeyword = id;
        this.linkLoading = true;
        GetLinkAddress({
          type,
          key: id,
        })
          .then((res) => {
            // this.linkSelfUrl = res.url;
            this.linkUrls = res.h5_urls;
            this.linkLoading = false;
          })
          .catch((e) => {
            this.$message.error(e);
          });
      }
    },
    // 打开复制链接窗口
    openCopyLink() {
      if (!this.showCopyLink) {
        this.showCopyLink = true;
      }
    },
    // 关闭复制链接窗口
    closeCopyLink() {
      if (this.showCopyLink) {
        this.showCopyLink = false;
      }
    },
    // 通过公众号的id查找到name
    getPublicName(id) {
      for (const item of this.allPubulcList) {
        if (item.app_id === id) {
          return item.app_name;
        }
      }
      return false;
    },
    // 复制链接
    // copyLink(id, type) {
    //   // 点击复制
    //   if (id) {
    //     GetLinkAddress({
    //       type,
    //       key: id,
    //     })
    //       .then((res) => {
    //         console.log(res);
    //         this.copylink = res.url;
    //         this.$refs.clickClipBoard.click();
    //       })
    //       .catch((e) => {
    //         this.$message.error(e);
    //       });
    //   } else {
    //     this.$message.error('暂无art_id');
    //   }
    // },
    // 查看记录
    viewRecord(row) {
      this.recordPopShow = true;
      this.targetId = row.art_id;
    },
    // 修改状态
    changColStatus(row, status) {
      this.targetId = row.art_id;
      // 上架
      if (status == 1) {
        this.setArticleStatus(status);
        // 下架
      } else if (status == 6) {
        this.dialogVisible = true;
      }
    },
    // 编辑
    editCol(row) {
      this.$emit('changeComponet', 'articleEdit', { id: row.art_id });
    },
    // 下架置灰
    tableRowDisabled({ row }) {
      if (row.status === 6) {
        return 'disabled_col';
      }
    },
    hanldeSelectAll(selection) {
      console.log('selection', selection);
      this.sortList = selection;
    },
    hanldeSelect(selection) {
      console.log('selection', selection);
      this.sortList = selection;
      // 数组截取8位 保护操作
    },
    // 是否可选
    selectable(row) {
      return row.status != 6;
    },
    currentChange(val) {
      this.form.page_index = val;
      this.getArticleList();
    },
    sizeChange(val) {
      this.form.page_index = 1;
      this.form.page_size = val;
      this.getArticleList();
    },
    // 搜索
    searchList() {
      this.loading = true;
      this.form.page_index = 1;
      // 将时间转化成秒
      if (this.searchTime && this.searchTime.length) {
        [this.form.operate_time_begin, this.form.operate_time_end] = [
          this.searchTime[0].getTime() / 1000,
          this.searchTime[1].getTime() / 1000 + 86399, // 一天的最后一秒
        ];
      } else {
        [this.form.operate_time_begin, this.form.operate_time_end] = ['', ''];
      }

      this.getArticleList(() => {
        this.$message.closeAll();
        if (this.tableData.length) {
          this.$message.success('搜索成功！');
        } else {
          this.$message.warning('暂无数据');
        }
      });
    },
    // 获取文章列表
    getArticleList(cb, noReset) {
      this.loading = true;
      const form = { ...this.form };
      if (form.time) {
        form.start_date = form.time[0];
        form.end_date = form.time[1];
      }
      delete form.time;
      for (const key in form) {
        if (!form[key]) {
          delete form[key];
        }
      }
      const tags = [];
      if (this.tagList.length) {
        this.tagList.forEach((e) => {
          tags.push({
            tag_type: (() => {
              if (e[0] === 'product') {
                return 1;
              }
              if (e[0] === 'departemt') {
                return 2;
              }
              return 3;
            })(),
            tag_id: String(e[1]),
          });
        });
        form.tags = tags;
      }
      this.exportForm = { ...form };
      getArticleListApi(form)
        .then((res) => {
          this.loading = false;
          this.sortList = [];
          if (!noReset) {
            this.tableData = [];
          }
          this.$nextTick(() => {
            this.tableData = res.art_list;
            if (cb) {
              cb();
            }
          });
          this.total = res.total;
        })
        .catch((e) => {
          this.loading = false;
          this.$message.error(e.message);
        });
    },
    // 获取公众号列表
    getAppList() {
      getAppListApi(this.pubulcForm)
        .then((res) => {
          this.allPubulcList = res.list;
        })
        .catch((err) => {
          console.error(err);
          this.$notify({
            message: '查询失败',
            type: 'success',
          });
        });
    },
    // 获取产品列表
    getProductInfoList() {
      GetProductInfoList().then((res) => {
        this.productList = res.list;
      });
    },
    remoteSearchStrategy(key) {
      this.strategyForm.strategy_name = key;
      this.getStrategyArr();
    },
    selectFocus(refName, arrName) {
      if (this[arrName].length == 0) {
        this.$refs[refName].remoteMethod();
      }
    },
    // 获取策略接口
    getStrategyArr() {
      getStrategyList(this.strategyForm)
        .then((res) => {
          this.strategyList = res.list;
        })
        .catch((e) => {
          this.$message.error(e.message);
        });
    },
    // 检查是否有投票
    checkAtricleIsHaveVote() {
      return new Promise((resolve, reject) => {
        const noPassList = [];
        let flag = false;
        this.sortList.forEach((a) => {
          // 如果支持投票就就不准提交
          if (a.vote_support_opt == 1) {
            flag = true;
            noPassList.push(a);
          }
        });
        if (flag) {
          this.noPassList = noPassList;
          this.hintVoteForbidShow = true;
          reject();
        } else {
          resolve();
        }
      });
    },
    // 校验文章
    verifyArticleList() {
      const havePaper = this.sortList.filter((e) => e.have_paper);
      const havePaperName = havePaper.map((e) => e.title);
      if (havePaper.length > 0) {
        this.$message.error(
          `以下文章"${havePaperName}"包含考卷，在公众号内无法正常显示，请编辑或重新选择`,
        );
        return;
      }
      if (this.sortList.length > this.selectLimit) {
        this.$message.error(`最多只能选择${this.selectLimit}篇`);
        return;
      }
      this.checkAtricleIsHaveVote()
        .then(() => {
          this.getDeletedMediaList().then(() => {
            this.openSortDialog();
          });
        })
        .catch(() => {});
    },
    // 打开排序弹窗
    openSortDialog() {
      const passArr = [];
      this.passAppArr.forEach((e) => {
        const flag = this.pubulcList.find((p) => {
          return e.app_id == p.app_id;
        });
        if (flag) {
          passArr.push(flag);
        }
      });
      if (!passArr.length) {
        this.$message.error('所选的文章不适用于任何一个公众号');
        return;
      }
      this.sortBoxVisible = true;
      this.$nextTick(() => {
        this.$refs.articleSortBox.setPassAppList(passArr);
        this.$refs.articleSortBox.setArticleSortList([...this.sortList]);
      });
    },
    // 弹窗确认按钮
    setArticleStatus(status) {
      setArticleStatusApi({
        art_id: this.targetId,
        status,
      })
        .then(() => {
          this.getArticleList(false, true);
          this.dialogVisible = false;
          this.$message.success(`${status == 1 ? '上架' : '下架'}成功!`);
        })
        .catch((e) => {
          this.$message.error(e.message);
        });
    },
    sendMiniProgram() {
      this.hasMediaList = this.HasVideoOrAudio();
      if (this.hasMediaList.length !== 0) {
        this.dialogHasMedia = true;
        return;
      }
      this.$confirm('确认发布小程序吗?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'orange_confirm',
        closeOnClickModal: false,
      }).then(() => {
        const artIds = this.sortList.map((e) => e.art_id);
        publishArticleToMiniApi({
          art_ids: artIds,
        })
          .then(() => {
            this.$refs.table.clearSelection();
            this.$message.success('发布成功!');
          })
          .catch((e) => {
            this.$message.error(e.message);
          });
      });
    },
    // 返回
    createMessage() {
      this.$emit('changeComponet', 'articleEdit');
    },
    // 改变选择的栏
    changeSelceltRow(item) {
      this.$refs.table.toggleRowSelection(item, false);
      this.$nextTick(() => {
        this.sortList = this.sortList.filter((e) => {
          return e.art_id != item.art_id;
        });
        console.log(this.sortList, 'sortList');
        // this.sortList.splice(item, 1);
      });
    },
    // 发布成功
    onPublishSuccess() {
      this.sortBoxVisible = false;
      this.getArticleList();
    },
    // 检查已选文章是否包含视频和音频，返回含有的文章数组
    HasVideoOrAudio() {
      const result = [];
      for (const item of this.sortList) {
        if (item.content_media_id !== '[]') {
          const medias = JSON.parse(item.content_media_id);
          console.log(medias);
          for (const media of medias) {
            if (media.mate_type === 2 || media.mate_type === 3) {
              result.push(item);
              break;
            }
          }
        }
      }
      return result;
    },
  },
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
